"use client";

import AdDetailModel from "@/models/AdDetailModel";
import { Box } from "@mui/material";
import AdPriceRibbon from "@/app/shared/ad/AdPriceRibbon";
import AdLabelRibbon from "@/app/shared/ad/AdLabelRibbon";

export default function AdDetailRibbons({ ad }: { ad: AdDetailModel }) {
  return (
    <Box
      sx={(theme) => ({
        position: "relative",
        display: "flex",
        marginTop: -8,
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
          marginTop: -6,
        },
      })}
    >
      <AdLabelRibbon ad={ad} />
      <AdPriceRibbon ad={ad} />
    </Box>
  );
}
